/**
 * Wraps the account and clinic pages. A staff member or clinic member whose session has not passed
 * its second factor is sent to finish signing in, with a way back to this page. Everyone else,
 * signed out included, sees the page as before: those pages handle their own sign-in.
 */
import type { ReactNode } from "react";
import { useEffect, useState } from "react";
import { secondFactorPathFor } from "@lattice/core";
import { loadSession } from "../api.ts";

export function SecondFactorGate({ children }: { readonly children: ReactNode }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    void loadSession().then(
      (loaded) => {
        const target = loaded.status === "ok" ? secondFactorPathFor(loaded.me) : null;

        if (target === null) {
          setReady(true);

          return;
        }

        const here = window.location.pathname + window.location.search;

        window.location.assign(`${target}?next=${encodeURIComponent(here)}`);
      },
      () => {
        /* No answer about who this is. The page asks for its own data and says if that fails. */
        setReady(true);
      },
    );
  }, []);

  return ready ? children : null;
}
